import classNames from "classnames";

/**
 * wrapper to make it easier to debug responsive breakpoints
 **/
export const ResponsiveContainer = ({
  debug = false,
  children,
}: {
  debug?: boolean;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={classNames(
        debug ? "tw:md:bg-green-600 tw:lg:bg-yellow-600 tw:xl:bg-red-600" : "",
        "tw:py-8"
      )}
    >
      {children}
    </div>
  );
};
